"use strict";
/**
 * ChatTurnContext 的 Zod 校验 schema —— 给内部 HTTP gateway（/api/internal/*）用
 *
 * NestJS 端口可用 `new ZodValidationPipe(chatTurnContextSchema)` 校验请求体。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.leadSubmitInputSchema = exports.chatTurnContextSchema = exports.aiStrategyViewSchema = exports.ticketPolicySchema = exports.leadCriteriaSchema = exports.emotionResultSchema = exports.intentResultSchema = exports.recordSourceSchema = exports.channelSchema = exports.leadFieldSchema = exports.emotionLabelSchema = exports.intentLabelSchema = void 0;
const zod_1 = require("zod");
exports.intentLabelSchema = zod_1.z.enum([
    'cs_qa',
    'complaint',
    'pricing',
    'chitchat',
    'spam',
    'unclear',
    'order_query',
    'logistics_query',
    'ticket_create',
    'ticket_query',
]);
exports.emotionLabelSchema = zod_1.z.enum([
    'positive',
    'neutral',
    'negative',
    'angry',
    'frustrated',
]);
exports.leadFieldSchema = zod_1.z.enum(['name', 'phone', 'wechat', 'email']);
exports.channelSchema = zod_1.z.enum(['web', 'digital_human']);
exports.recordSourceSchema = zod_1.z.enum([
    'web',
    'digital_human',
    'api',
    'admin',
]);
exports.intentResultSchema = zod_1.z.object({
    intent: exports.intentLabelSchema,
    inScope: zod_1.z.boolean(),
    needsHuman: zod_1.z.boolean(),
    reason: zod_1.z.string(),
    intentConfidence: zod_1.z.number().min(0).max(1).optional(),
});
exports.emotionResultSchema = zod_1.z.object({
    label: exports.emotionLabelSchema,
    score: zod_1.z.number().min(0).max(1),
    reason: zod_1.z.string(),
});
exports.leadCriteriaSchema = zod_1.z.object({
    minScore: zod_1.z.number().min(0).max(100),
    minRounds: zod_1.z.number().int().nonnegative(),
    askTemplate: zod_1.z.string(),
    requiredFields: zod_1.z.array(exports.leadFieldSchema),
    crossConvCooldownHours: zod_1.z.number().int().nonnegative(),
    submittedCooldownHours: zod_1.z.number().int().nonnegative(),
});
exports.ticketPolicySchema = zod_1.z.object({
    negativeEmotionThreshold: zod_1.z.number().min(0).max(1),
    keywords: zod_1.z.array(zod_1.z.string()),
});
exports.aiStrategyViewSchema = zod_1.z.object({
    csId: zod_1.z.string(),
    industry: zod_1.z.string().nullable(),
    productKeywords: zod_1.z.array(zod_1.z.string()),
    chitchatPolicy: zod_1.z.enum(['strict', 'loose']),
    mainModel: zod_1.z.string(),
    auxModel: zod_1.z.string(),
    systemPromptOverride: zod_1.z.string().nullable(),
    leadCriteria: exports.leadCriteriaSchema,
    ticketPolicy: exports.ticketPolicySchema,
    enableLeadCapture: zod_1.z.boolean(),
    enableTicketAutoCreate: zod_1.z.boolean(),
});
exports.chatTurnContextSchema = zod_1.z.object({
    channel: exports.channelSchema,
    conversation: zod_1.z.object({
        id: zod_1.z.string(),
        csId: zod_1.z.string(),
        siteId: zod_1.z.string(),
        merchantId: zod_1.z.string(),
        visitorId: zod_1.z.string(),
        locale: zod_1.z.string().nullable(),
        round: zod_1.z.number().int().nonnegative(),
    }),
    customerService: zod_1.z.object({
        id: zod_1.z.string(),
        fallbackMsg: zod_1.z.string().nullable(),
        welcomeMsg: zod_1.z.string().nullable(),
        guideMsg: zod_1.z.string().nullable(),
        i18n: zod_1.z.unknown().nullable(),
        quickQuestions: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string(),
            text: zod_1.z.string(),
            i18n: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
        })),
    }),
    strategy: exports.aiStrategyViewSchema,
    currentMessage: zod_1.z.object({
        id: zod_1.z.string(),
        text: zod_1.z.string(),
        msgType: zod_1.z.enum(['text', 'image', 'emoji', 'voice']),
    }),
    recentMessages: zod_1.z.array(zod_1.z.object({
        role: zod_1.z.enum(['visitor', 'ai']),
        text: zod_1.z.string(),
        ts: zod_1.z.number(),
    })),
    precomputed: zod_1.z
        .object({
        intent: exports.intentResultSchema.optional(),
        emotion: exports.emotionResultSchema.optional(),
    })
        .optional(),
});
exports.leadSubmitInputSchema = zod_1.z.object({
    source: exports.recordSourceSchema,
    siteId: zod_1.z.string(),
    merchantId: zod_1.z.string(),
    visitorId: zod_1.z.string().nullable(),
    sourceConvId: zod_1.z.string().nullable(),
    sourceMessageId: zod_1.z.string().nullable(),
    score: zod_1.z.number().int().min(0).max(100).optional(),
    fields: zod_1.z.object({
        name: zod_1.z.string().max(64).optional(),
        phone: zod_1.z.string().max(32).optional(),
        wechat: zod_1.z.string().max(64).optional(),
        email: zod_1.z.string().email().max(128).optional(),
        company: zod_1.z.string().max(128).optional(),
    }),
    note: zod_1.z.string().optional(),
});
//# sourceMappingURL=chat-turn.js.map